// extracted by mini-css-extract-plugin
module.exports = {"titleHome":"titleHome_titleHome__3BeVt","titleHomeMobile":"titleHome_titleHomeMobile__3_MBS"};